"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Credits_1 = require("../../../parts/Credits");
exports.default = Credits_1.Credits;
//# sourceMappingURL=Credits.js.map